<template>
  <b-modal :id="modalId" hide-footer size="xl" scrollable>
    <template #modal-title>
      <div class="d-flex align-items-center justify-content-between w-100">
        <span>{{ activeTabTitle }}</span>
        <b-button size="sm" variant="outline-primary" style="margin-left: 15px;" @click="$emit('download')">
          <b-icon-download /> Tải xuống (.doc)
        </b-button>
      </div>
    </template>
    <div class="p-1 modal-expanded-body">
      <p style="font-style: italic; color: #555555; font-size: 10.5pt; margin-top: 0; margin-bottom: 15px;">
        {{ $t('aiSummaryDisclaimer') }}
      </p>

      <!-- Tab tóm tắt chung -->
      <div v-if="activeContentTab === 'general' && summaryArry.length > 0">
        <div v-for="(item, index) in summaryArry" :key="index" class="mb-4">
          <div class="summary-type-header">{{ getSummaryType(index) }}</div>
          <div v-html="formattedSummaryMeeting(item)" class="tab-content-html"></div>
        </div>
      </div>

      <!-- Tab Summary of Timeline -->
      <div v-if="activeContentTab === 'timeline' && summaryByTimeline.length > 0">
        <div v-for="(html, index) in formattedTimelineList" :key="'timeline-' + index" v-html="html" class="tab-content-html mb-3"></div>
      </div>

      <!-- Tab tóm tắt theo người phát biểu -->
      <div v-if="activeContentTab === 'speaker' && summaryAllUser.length > 0">
        <div v-for="(item, index) in summaryAllUser" :key="index" class="mb-3">
          <b class="text-dark d-block mb-1">{{ item.name }}</b>
          <div v-html="formatSummary(item.summary)" class="tab-content-html"></div>
        </div>
      </div>
     
      <!-- Export tab -->
      <div v-if="activeContentTab === 'content' && contentRoom">
        <div v-html="formattedContentRoom" class="tab-content-html"></div>
      </div>
    </div>
  </b-modal>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import * as util from "@/service/util";

@Component
export default class ExpandedContentModal extends Vue {
  @Prop({ required: true }) modalId!: string;
  @Prop({ default: "" }) activeTabTitle!: string;
  @Prop({ default: "" }) activeContentTab!: string;
  @Prop({ default: () => [] }) summaryArry!: any[];
  @Prop({ default: () => [] }) summaryByTimeline!: any[];
  @Prop({ default: () => [] }) summaryAllUser!: any[];
  @Prop({ default: "" }) contentRoom!: string;
  @Prop({ default: () => [] }) formattedTimelineList!: string[];
  @Prop({ default: "" }) formattedContentRoom!: string;

  getSummaryType(index: number) {
    return util.SUMMARY_TYPE_LABELS[index] || `${this.$t('summary')} ${index + 1}`;
  }

  formattedSummaryMeeting(stringSum: string) {
    const renumbered = util.renumberMarkdownHeadings(stringSum, 1);
    const formated = util.convertTitleSummaryMeeting(renumbered, true);
    return util.markdownToHtml(formated);
  }

  formatSummary(text: string) {
    if (!text) return "";
    return util.markdownToHtml(text);
  }
}
</script>

<style lang="scss" scoped>
.modal-expanded-body {
  font-size: 16px;
  color: #374151;
  position: relative;
}

.floating-content-actions {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  gap: 8px;
  z-index: 100;
}

.floating-content-actions .action-btn {
  background: rgba(255, 255, 255, 0.75) !important;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid rgba(229, 231, 235, 0.9) !important;
  color: #4b5563 !important;
  padding: 6px 8px !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05) !important;
  transition: all 0.2s ease-in-out;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.floating-content-actions .action-btn:hover {
  background: rgba(255, 255, 255, 0.95) !important;
  color: #1f2937 !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08) !important;
}

.summary-type-header {
  font-size: 19px !important;
  line-height: 1.7;
  color: #004f9e !important;
  font-weight: 700 !important;
  margin-top: 12px;
  margin-bottom: 8px;
}

::v-deep .tab-content-html {
  line-height: 1.7;
  font-size: 16px;
  color: #374151;
  
  // Tiêu đề 
  h1, h2, h3, h4, h5, h6 {
    font-family: inherit;
    color: #475569 !important; 
    font-weight: 600 !important;
    margin-top: 1.25rem !important;
    margin-bottom: 0.5rem !important;
    line-height: 1.3 !important;
  }
  
  h1 { font-size: 18.5px !important; }
  h2 { font-size: 17.5px !important; margin-top: 1rem !important; }
  h3 { font-size: 16.5px !important; }
  h4 { font-size: 15.5px !important; }

  // Các đoạn văn
  p {
    margin-bottom: 0.5rem !important;
  }

  div {
    margin-bottom: 0.25rem !important;
  }

  // Danh sách
  ul, ol {
    margin-top: 0.2rem !important;
    margin-bottom: 0.5rem !important;
    padding-left: 1.25rem !important;
    
    li {
      margin-bottom: 0.2rem !important;
      line-height: 1.5 !important;
    }
  }

  ul {
    list-style-type: disc !important;
  }
  
  ol {
    list-style-type: decimal !important;
  }

  // In đậm & in nghiêng
  strong {
    color: #0f172a; // Slate-900 giúp chữ in đậm sắc nét
    font-weight: 600;
  }

  em {
    color: #4b5563;
  }

  // Bảng biểu
  table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    margin-top: 0.75rem;
    margin-bottom: 1.5rem;
    border-radius: 6px;
    border: 1px solid #e2e8f0;
    overflow: hidden;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);

    th, td {
      padding: 10px 14px;
      font-size: 13.5px;
      line-height: 1.5;
    }

    th {
      background-color: #f8fafc;
      color: #1e293b;
      font-weight: 600;
      border-bottom: 1px solid #cbd5e1;
      border-right: 1px solid #e2e8f0;
      text-align: left;
      
      &:last-child {
        border-right: none;
      }
    }

    td {
      color: #334155;
      border-bottom: 1px solid #f1f5f9;
      border-right: 1px solid #f1f5f9;
      background-color: #ffffff;
      
      &:last-child {
        border-right: none;
      }
    }

    tr:last-child td {
      border-bottom: none;
    }

    tr:nth-child(even) td {
      background-color: #f8fafc; // Xen kẽ màu dòng
    }
  }

  // Liên kết & mã code inline
  a {
    color: #2563eb;
    text-decoration: underline;
    transition: color 0.15s ease;
    
    &:hover {
      color: #1d4ed8;
    }
  }

  code {
    font-family: Menlo, Monaco, Consolas, "Courier New", monospace;
    background-color: #f1f5f9;
    color: #e11d48;
    padding: 0.2em 0.4em;
    border-radius: 4px;
    font-size: 85%;
    font-weight: normal;
  }

  // Khối mã nguồn
  pre {
    background-color: #0f172a;
    border-radius: 6px;
    padding: 12px 16px;
    margin: 1rem 0;
  }
}
</style>
